import React from "react";
import { Link } from "react-router-dom";
import { FacebookLogo, InstagramLogo, TiktokLogo } from "@phosphor-icons/react";
import { useSettings } from "@/context/SettingsContext";

const SOCIALS = [
  { key: "facebook", label: "Facebook", Icon: FacebookLogo },
  { key: "instagram", label: "Instagram", Icon: InstagramLogo },
  { key: "tiktok", label: "TikTok", Icon: TiktokLogo },
];

export const Footer = () => {
  const { settings } = useSettings();
  const social = settings?.social || {};
  const links = SOCIALS.filter((s) => (social[s.key] || "").trim());

  return (
    <footer className="border-t border-white/10 bg-[#0A0A0A] mt-24">
      <div className="max-w-7xl mx-auto px-6 py-12 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img src="/iefsc-logo.png" alt="IEFSC" className="w-10 h-10 object-contain" />
          <span className="font-display text-3xl text-[#FF5722]">IEFSC</span>
        </div>

        {links.length > 0 && (
          <div className="flex items-center gap-3" data-testid="footer-social-links">
            {links.map(({ key, label, Icon }) => (
              <a
                key={key}
                href={social[key].trim()}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                title={label}
                data-testid={`footer-social-${key}`}
                className="w-10 h-10 flex items-center justify-center border border-white/15 text-white/60 hover:text-black hover:bg-[#FF5722] hover:border-[#FF5722] transition-all duration-200"
              >
                <Icon size={20} weight="fill" />
              </a>
            ))}
          </div>
        )}

        <p className="text-white/40 text-sm tracking-wide">
          © {new Date().getFullYear()} IEFSC. Built for ballers. · <Link to="/seasons" data-testid="footer-past-seasons" className="hover:text-[#FF5722] transition-colors">Past Seasons</Link>
        </p>
      </div>
    </footer>
  );
};
